import { render, staticRenderFns } from "./ListOV.vue?vue&type=template&id=1a644a7e&scoped=true&lang=pug"
import script from "./ListOV.vue?vue&type=script&lang=js"
export * from "./ListOV.vue?vue&type=script&lang=js"
import style0 from "./ListOV.vue?vue&type=style&index=0&id=1a644a7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a644a7e",
  null
  
)

export default component.exports